import actions from "./actions"
import mutations from "./mutations"
import getters from "./getters"
import { initialState } from "./state"

import Combos from "./Combos"
import Separate from "./Separate"

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
  getters,
  modules: {
    Combos,
    Separate
  }
}
